<template>
<div id="catalogo_reglas_plazo">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs12>
        <base-material-card color="primary" icon="library_books" title="Administrar Reglas de Plazo" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">
              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id); openModal(2);" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text">
            {{ update ? "edit" : "add" }}
          </v-icon>&nbsp;
          <span class="subheading">
            <strong>{{ update ? "Actualizar" : "Nueva" }} Regla de Plazo</strong>
          </span>
        </v-card>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="modal = false" class="close_modal">
          <v-icon class="white--text">cancel</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md text-xs-center @keyup.enter="guardar()">
            <v-row row wrap>
            <v-col sm="12" md="10" lg="10">
                <v-text-field label="Regla de Plazo" v-model="model.regla_plazo" :rules="[rules.required]" maxlength="50"></v-text-field>
              </v-col>
              <v-col sm="12" md="2" lg="2">
                      <label>Certificación</label>  
              <v-switch v-model="model.certificacion" color="primary" :label="model.certificacion" true-value="SI" false-value="NO" style="margin-top:-10px"></v-switch>
            </v-col>
            </v-row>
            <v-row row wrap>
              <v-col sm="12" md="6" lg="6">
                <v-text-field label="Tipo de Programa" v-model="model.tipo_programa" :rules="[rules.required]" maxlength="100"></v-text-field>
              </v-col>
              <v-col sm="12" md="6" lg="6">
                <v-text-field label="Modalidad" v-model="model.modalidad" :rules="[rules.required]" maxlength="100"></v-text-field>
              </v-col>
             
            </v-row>
            <v-row row wrap>
              <v-col sm="12" md="6" lg="6">
                <v-text-field label="Rubro CIVA" v-model="model.tipo_civa" :rules="[rules.required]" maxlength="10"></v-text-field>
              </v-col>
              
              <v-col sm="12" md="6" lg="6">
              
                <v-autocomplete v-model="model.clave_documento" 
                                    :items="claves" :hide-no-data="true"     
                                    clearable :loading="clave_loading"  
                                    :return-object="false"  label="Clave Documento">
                                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col sm="12" md="4" lg="4">
                <v-text-field label="Plazo Expresado en Meses" type="number" v-model="model.tiempos" :rules="[rules.required]" min="0" max="999"></v-text-field>
              </v-col>
              <v-col sm="12" md="4" lg="4">
                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }" >
                    <v-text-field v-on="on" v-model="model.fecha_inicio" label="Fecha de Inicio" color="secondary" prepend-icon="event" @blur="model.fecha_inicio = parseDate(model.fecha_inicio)" :rules="[rules.required, validaFecha]" v-mask="'####-##-##'">
                    </v-text-field>
                  </template>

                  <v-date-picker v-model="model.fecha_inicio" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu1 = false" >
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="12" md="4" lg="4">
                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }" >
                    <v-text-field v-on="on" v-model="model.fecha_fin" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_fin = parseDate(model.fecha_fin)" :rules="[rules.required, validaFecha]" v-mask="'####-##-##'">
                    </v-text-field>
                  </template>

                  <v-date-picker v-model="model.fecha_fin" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu2 = false" >
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col s12 m12 l12>
                <v-textarea label="FRACCIONES" v-model="model.fracciones" rows="1"></v-textarea>
                <v-icon small color="blue">info</v-icon><small style="color:#2196F3;">Puede agregar varias fracciones separadas por coma ","</small><p/>

              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col s12 m12 l12>
                <v-textarea label="Anotaciones" v-model="model.anotaciones" rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="modal = false">
          <v-icon>cancel</v-icon>Cancelar
        </v-btn>
        <v-btn color="success" :loading="loading" @click.native="guardar()">
          <v-icon>done</v-icon>
          {{ update ? "Actualizar" : "Guardar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    claves:[],
    menu1: false,
    menu2: false,
    columns: ["regla_plazo" , "tipo_programa", "modalidad", "tipo_civa", "certificacion", "clave_documento", "tiempos", "fecha_inicio", "fecha_fin", "fracciones", "anotaciones", "actions"],
    options: {
      filterable: ["tipo_programa", "modalidad", "tipo_civa", "certificacion", "regla_plazo", "clave_documento", "tiempos", "fecha_inicio", "fecha_fin","fracciones", "anotaciones"],
      sortable: ["tipo_programa", "modalidad", "tipo_civa", "certificacion", "regla_plazo", "clave_documento", "tiempos", "fecha_inicio", "fecha_fin", "fracciones", "anotaciones"],
      headings: {
        tipo_programa: "Tipo de Programa",
        modalidad: "Modalidad",
        tipo_civa: "Rubro CIVA",
        certificacion: "Certificación",
        regla_plazo: "Regla de Plazo",
        clave_documento: "Clave de Documento",
        tiempos: "Plazo Expresado en Meses",
        fecha_inicio: "Fecha Inicio",
        fecha_fin: "Fecha Final",
        anotaciones: "Anotaciones",
        fracciones: "Fracciones",
        actions: "Operaciones"
      }
    },
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },      
      {
        text: "Reglas de Plazo",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    update: false,
    model: {},
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    items: []
  }),
  methods: {
    openModal: function(type) {
      if (type === 1) {
        this.model = this.clean_model();
        this.title = "Nueva Reglas de Plazo";
        this.update = false;
        if(this.items.length>0){
            this.getRegistro(this.items[this.items.length -1].id);
        }
      } else {
        this.title = "Actualizar Regla de Plazo";
        this.update = true;
        
      }
      this.modal = true;
    },
    getClaves:function(){
       this.clave_loading = true;
        var data = {
            //"identificador": this.model.activo, //identificador de activo fijo N -> No, S -> Si, "" -> Todos
            "rfc":this.$local_storage.get('rfc'),
        };
        
        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/get_claves_documento_a31/",            
            data: data
          })
          .then(response => {
                if(response.data && response.data.length){
                    this.claves = response.data
                } else {
                    this.claves = [];
                }                    
          }).catch(error => {            
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener las claves documentos. Intente nuevamente.",
              footer: ""
            });
          }).then(()=>{
            this.clave_loading = false;
          }); 
    },
    clean_model: function() {
      return {
        id_cliente: this.$local_storage.get('id_cliente'),
        tipo_programa: "",
        modalidad: "",
        tipo_civa: "",
        certificacion:"NO",
        regla_plazo: "",
        clave_documento:"",
        tiempos:0,
        fecha_inicio:"",
        fecha_fin:"",
        anotaciones:""
      }
    },
    guardar() {
      const datos = this.model;

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        var metodo = "post";

        if (this.update == true) {
          var url = this.$apiSA31 + "soluciona31/catalogos/reglas_plazo/actualizar/";
        } else {
          var url = this.$apiSA31 + "soluciona31/catalogos/reglas_plazo/guardar/";
          delete datos['id'];
        }

        axios({
            method: metodo,
            url: url,
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
            this.cargar();
            this.modal = false;
          })
          .catch(error => {
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos"
              //showConfirmButton: false,
            });
            console.log(error);
            this.cargar();
            this.modal = false;
          });
      }
    },
    cargar: function() {
      var url = this.$apiSA31 + "soluciona31/catalogos/reglas_plazo/listar/";
      axios
        .post(url, {"id_cliente": this.model.id_cliente})
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var url = this.$apiSA31 + "soluciona31/catalogos/reglas_plazo/listar/";
      axios
        .post(url, {"id_cliente": this.$local_storage.get('id_cliente'), "id": id_registro})
        .then(response => {
          this.model = response.data;
          
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro
    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          var url = this.$apiSA31 + "soluciona31/catalogos/reglas_plazo/eliminar/";
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios
            .post(url, {"id": id_registro})
            .then(response => {
              this.cargar();
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                //position: 'bottom-end',
                //timer: 3000,
                //showConfirmButton: false,
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro",
                footer: ""
              });
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        }
      });
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida.";
      else
        return true;
    },

  }, //methods
  created: function() {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.model = this.clean_model();
    this.cargar();
    this.getClaves();
  }
};
</script>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
